<div
  class="container d-flex justify-content-between align-items-center mobile-flex"
  style="margin-top: 30px"
>
  <app-linker-route
    [headingName]="headingName"
    [linkerRouteItems]="linkerRouteItems"
    style="margin-top: -20px"
  ></app-linker-route>

  <div class="row providerBox div-box">
    <div class="form-group has-search mb-0" style="width: 100%">
      <span class="fa fa-search form-control-feedback"></span>
      <input
        type="text"
        class="form-control mob-input"
        [(ngModel)]="serviceName"
        placeholder="Search for a booking provider"
        (input)="getServiceList()"
      />
    </div>
  </div>
</div>
<div class="container mb-5 wrapper-content" style="padding-left: 0px">
  <sub-category-filter
    type="service"
    (onSelectCategory)="getServiceList($event)"
  ></sub-category-filter>
  <div class="row row-cols-sm-2 row-cols-md-3 row-cols-lg-4 row-cols-xl-5 mt-3">
    <ng-container *ngIf="productDetails?.length">
      <div
        class="col newCardWidth mb-3"
        *ngFor="let item of productDetails"
        style="margin-left: 7px"
      >
        <div class="innerDiv">
          <service-card
            [data]="item"
            [desc]="desc"
            [catName]="catName"
            (on_Click)="navigateToserviceAvailableAdd(item?._id)"
          ></service-card>
        </div>
      </div>
    </ng-container>

    <ng-container *ngIf="!productDetails?.length && !isLoading">
      <div class="col newCardWidth mb-3" *ngFor="let item of length(10)">
        <div class="innerDiv">
          <service-card [data]="{}" [desc]="''" [catName]="''"></service-card>
        </div>
      </div>
    </ng-container>

    <div *ngIf="isLoading" class="no-data" style="text-align: center">
      <img
        src="assets/images/notfound.png"
        alt="No Data Found"
        class="notfound-img"
        style="width: auto; max-width: 100px"
      />
      <p style="text-align: center; font-size: 16px; font-weight: 500">
        No Data Found
      </p>
    </div>
  </div>
</div>
